/**
 * The portal accounts of one supplier.
 */
define('portalUsersListView',[
  'module',
  'marionette',
  'underscore',
  'app',
  'jquery',
  'bootbox',
  'dateUtils',
  'template!portalUsersListTpl',
  'template!portalUsersRowTpl'
], function (
  Module,
  Marionette,
  _,
  App,
  $,
  Bootbox,
  DateUtils,
  listTpl,
  rowTpl
) {
  'use strict';

  var STATUS_LABELS = {
    INVITED: 'Invited',
    ACTIVE: 'Active',
    DISABLED: 'Revoked'
  };

  var PortalUserRowView = Marionette.ItemView.extend({
    template: rowTpl,
    tagName: 'tr',
    className: 'portal-user-row',

    events: {
      'click .js-invite': 'onInvite',
      'click .js-disable': 'onDisable',
      'click .js-enable': 'onEnable',
      'click .js-unlock': 'onUnlock',
      'change .js-notify': 'onNotifyChange'
    },

    serializeData: function () {
      var data = this.model.toJSON();
      var status = data.status || 'INVITED';

      data.status = status;
      data.statusLabel = _.i18n('portalUsers.status.' + status.toLowerCase(), null, STATUS_LABELS[status] || status);
      data.displayName = _.compact([data.firstName, data.lastName]).join(' ') || '—';
      data.locked = data.locked === true;
      data.notifyNewOrders = data.notifyNewOrders === true;
      data.lastLoginLabel = data.lastLoginAt ?
        DateUtils.toDateTimeFormatString(data.lastLoginAt) :
        _.i18n('portalUsers.neverSignedIn', null, 'Never');

      // An invited account has not used its link yet, so "resend" is the honest
      // word; an active one is having its password reset.
      data.inviteLabel = status === 'INVITED' ?
        _.i18n('portalUsers.resendInvite', null, 'New link') :
        _.i18n('portalUsers.resetPassword', null, 'Reset password');

      return data;
    },

    onInvite: function () {
      this.run(App.request('portal-users:invite', this.model.get('secId')), _.bind(function (response) {
        this.trigger('invite:issued', response);
      }, this));
    },

    onDisable: function () {
      Bootbox.confirm(_.i18n('portalUsers.confirmDisable', null,
        'Revoke this account? They are signed out immediately and cannot sign in again until you reopen it.'),
        _.bind(function (confirmed) {
          if (confirmed) {
            this.run(App.request('portal-users:disable', this.model.get('secId')));
          }
        }, this));
    },

    onEnable: function () {
      this.run(App.request('portal-users:enable', this.model.get('secId')), _.bind(function (response) {
        this.trigger('invite:issued', response);
      }, this));
    },

    onUnlock: function () {
      this.run(App.request('portal-users:unlock', this.model.get('secId')));
    },

    onNotifyChange: function (event) {
      this.run(App.request('portal-users:set-notify-new-orders', this.model.get('secId'), event.currentTarget.checked));
    },

    /** Every action reloads the list, so the row never shows stale status. */
    run: function (request, onDone) {
      this.$el.addClass('busy');
      $.when(request)
        .done(_.bind(function (response) {
          if (onDone) {
            onDone(response);
          }
          this.trigger('changed');
        }, this))
        .fail(_.bind(function (xhr) {
          this.$el.removeClass('busy');
          this.trigger('failed', xhr);
        }, this));
    }
  });

  Module.exports = Marionette.CompositeView.extend({
    template: listTpl,
    childView: PortalUserRowView,
    childViewContainer: 'tbody',
    className: 'portal-users-list-view',

    childEvents: {
      'changed': function () {
        this.trigger('changed');
      },
      'invite:issued': function (child, response) {
        this.trigger('invite:issued', response);
      },
      'failed': function (child, xhr) {
        this.trigger('failed', xhr);
      }
    },

    emptyView: Marionette.ItemView.extend({
      tagName: 'tr',
      className: 'empty-row',
      template: _.template('<td colspan="6"><%= label %></td>'),
      serializeData: function () {
        return {
          label: _.i18n('portalUsers.empty', null,
            'No portal account for this supplier yet.')
        };
      }
    })
  });
});

